export const FIELD_MAPPINGS = {
  functionalcurrency: 'functionalCurrency',
  trialbalanceoutofbalancethreshold: 'trialBalanceThreshold',
};
export const MIN_COLUMNS_NUMBER = 2;
export const MAX_COLUMNS_NUMBER = 2;
